// @flow
import moment from 'moment'

import ReservationModel from 'frontend_core/dist/model/Reservation'
import SMConst from 'frontend_core/dist/constants/sm-const'

import Path from 'routes/path'
import { type ReservationType } from 'types/v1/reservation'

function getReservationCurrentStatus(currentReservationStatus: number) {
  switch (currentReservationStatus) {
    case SMConst.ReservationStatus.Confirmed:
    case SMConst.ReservationStatus.Paid:
    case SMConst.ReservationStatus.Onsite:
    case SMConst.ReservationStatus.Invoice:
    case SMConst.ReservationStatus.Ended:
    case SMConst.ReservationStatus.Postpay:
      return 'hasCompletedReservation'
    case SMConst.ReservationStatus.Sent:
      return 'hasSentInquiry'
    case SMConst.ReservationStatus.Expired:
      return 'hasExpired'
    default:
      return null
  }
}

export function getReservationCurrentStatusSectionProps(
  reservation: ReservationType,
  onClickLink: (e?: ?Event, url: string, newWindow?: boolean) => void,
) {
  const reservedRoom = reservation.room || {}
  const reservedSpace = reservedRoom.space || {}
  const reservedBilling = reservation.billing || {}
  const owner = reservation.owner || {}

  const hasChangeRequestFromOwner = ReservationModel.hasChangeRequestFromOwner(
    reservation,
  )
  const hasChangeRequestFromUser = ReservationModel.hasChangeRequestFromUser(
    reservation,
  )

  let hostActionStatus = ''
  if (hasChangeRequestFromOwner) {
    hostActionStatus = 'hasChangeRequestFromHost'
  } else if (hasChangeRequestFromUser) {
    hostActionStatus = 'hasChangeRequest'
  } else if (reservation.status === SMConst.ReservationStatus.Refunded) {
    hostActionStatus = 'hasGuestCancelRefund'
  } else if (reservation.can_be_paid) {
    hostActionStatus = 'hasChangeRequestInquiry'
  }

  const canBeReview = reservation.can_be_reviewed

  return {
    phaseText: reservation.phase_text || reservation.status_text || '',
    isTypeStay: reservation.rent_type === SMConst.RentType.Stay,
    isActiveReservation: ReservationModel.isActive(reservation),
    reservationStatus: reservation.status,
    reservationStatusType: getReservationCurrentStatus(reservation.status),
    directReservation: reservation.is_direct,
    onClickChangeInquiryToReservation: e =>
      onClickLink(
        e,
        Path.roomReservationRequest(
          reservedSpace.username,
          reservedRoom.uid,
          reservation.uid,
        ),
        true,
      ),
    onClickSelectPayment: e =>
      onClickLink(e, Path.reservationSelectPayment(reservation.uid)),
    onClickRecreateReservation: e =>
      onClickLink(
        e,
        Path.roomReservationRequest(reservedSpace.username, reservedRoom.uid),
        true,
      ),

    dayOfTerm: canBeReview
      ? reservation.remaining_days_for_review_expires
      : reservation.remining_days_for_approval,
    dueDate: canBeReview
      ? reservation.review_expires_at
      : reservation.due_date_for_approval,
    canBeReview,
    onClickPostReview: e =>
      onClickLink(e, Path.reservationReputation(reservation.uid)),

    hostActionStatus,
    refundAmount: reservedBilling.refunded_amount_text,
    onClickChangeRequestFromUser: e =>
      onClickLink(e, Path.reservationChangeGuest(reservation.uid)),
    onClickChangeRequestFromOwner: e =>
      onClickLink(e, Path.reservationChangeHost(reservation.uid)),

    onClickItinerary: e =>
      onClickLink(e, Path.itinerary(reservation.uid), true),

    telNumber: owner.tel || '',
    onClickEventServiceLp: e =>
      onClickLink(e, Path.eventServiceLp(reservation.uid), true),
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationCurrentStatusSection/presenter.js